<template>
  <!-- 底栏 -->
  <div class="b">
    <div>
      <div>
        <div>
          <img style=" height: 68px;" :src="logo" />
          <div style="margin-top: 24px;">地址：{{ copyright.areaProvinceName }}{{ copyright.areaCityName }}{{ copyright.areaNameName }}{{
              copyright.addressName }}</div>
          <div style="margin-top: 24px;">邮编：{{ copyright.postcode }} 邮箱：{{ copyright.kcServer  }}</div>

        </div>
        <div></div>
        <div>
          <div style="font-size: 18px;margin-top: 0;">快速链接</div>
          <div style="cursor: pointer;" v-for="(item,index) in members" @click="toISOString(item)" :key="item.id">{{item.name}}</div> 
        </div>
        <div>
          <div style="font-size: 18px;margin-top: 0;">联系我们</div>
          <div style="font-family: MiSans, MiSans;">
            <img src="https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/x2.png" alt="">
           {{ copyright.mobile }}
          </div>
          <div>
            <img src="https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/x3.png" alt="">
            周一至周六 <span style="font-family: MiSans, MiSans;">09:00-17:00</span> 
          </div>
        </div>
      </div>
    </div>
    <div></div>
      <div  v-html="copyright.copyright" />
    
  </div>
</template>
<script>
import Bus from '@/api/bus'
import Vue from 'vue'
import { getImagePage } from '@/api/home'
import { getDomain, getDomainLogo } from '@/api/cookies'
import { getInfo } from '@/api/cookies'
// import { JuxueU } from '@/api/JuxueU'
// const juxueU = new JuxueU()
import { TeacherClient } from '@/api/teacherClient.js'
let teacherClient = new TeacherClient()
export default {
  data() {
    return {
      path: '/',

      logo: '',
      copyright: {},
      members: []

    }
  },

  async created() {
    this.path = window.location.pathname
    this.userInfo = getInfo()
    this.logo = getDomainLogo()
    this.copyright = getDomain()
  teacherClient.getEntrantsRelation({

    }).then((res) => {
      this.members = res.data.linkVoList.splice(0,3)
    })
  },
  mounted() {

  },
  methods: {
      toISOString(item) {
      if (item.nameUrl) {
        window.open(item.nameUrl, '_blank')
      }
    },
    gopage(path, type) {
      if (this.path == path) {
        return
      }
      if (type) {
        // window.open(path, "_blank");
        this.$router.push(path)
      } else {
        /* this.$router.push(path); */
        // window.open(path, "_blank");
        this.$router.push(path)
      }
    },

  }
}
</script>
<style lang="less" scoped>
.b {
  width: 100%;
  height: 282px;
  background: url('https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/x1.png');
  background-size: 100% 100%;
  padding: 32px 0 24px 0;

  >div:nth-child(1) {
    width: 1200px;
    margin: 0 auto;

    >div:nth-child(1) {
      display: flex;

      >div:nth-child(1) {
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: 400;
        font-size: 12px;
        color: #F7F7F7;
      }

      >div:nth-child(2) {
        width: 0px;
        height: 122px;
        border: 1px solid #6A82AE;
        margin: 0 76px;
        margin-top: 20px;
      }

      >div:nth-child(3) {
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: 400;
        font-size: 14px;
        color: #F7F7F7;
        margin-right: 64px;

        >div {
          margin-top: 24px;
        }
      }

      >div:nth-child(4) {
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: 400;
        font-size: 14px;
        color: #F7F7F7;

        >div {
          display: flex;
          align-items: center;
          margin-top: 24px;

          img {
            width: 12px;
            margin-right: 10px;
          }
        }
      }
    }
  }
  >div:nth-child(2){
    width: 1200px;
height: 0px;
border: 1px solid #6A82AE;
margin: 0 auto;
margin-top: 40px;

  }
  >div:nth-child(3){
   
font-family: Microsoft YaHei, Microsoft YaHei;
font-weight: 400;
font-size: 12px;
color: #F7F7F7; 
margin-top: 20px;
text-align: center;
  }

}
</style>
